import React from 'react';

import { closeCurrentPopup } from '@paragon/popup-state';

import { deleteComponentDesignsWithoutConfirmation } from '../../store/actions/deletionActions';
import { ComponentDesignConfirmationProps } from '../../store/actions/popupActions';
import { useAppDispatch, useAppSelector } from '../hooks';
import { ConfirmDialog } from './ConfirmDialog';

export function DeleteComponentDesignConfirmDialog({ componentDesignGuids }: ComponentDesignConfirmationProps) {
  const dispatch = useAppDispatch();

  const componentDesigns = useAppSelector((state) => state.componentDesigns.data);
  const singleComponentDesignName =
    componentDesignGuids.length === 1 ? componentDesigns[componentDesignGuids[0]].component.name : null;

  const message =
    'Are you sure you want to delete ' +
    (componentDesignGuids.length > 1
      ? `${componentDesignGuids.length} Components?`
      : `Component ${singleComponentDesignName}?`);

  return (
    <ConfirmDialog
      open
      title="Confirm Delete"
      message={message}
      onClose={(confirmed) => {
        dispatch(closeCurrentPopup());
        if (confirmed) {
          dispatch(deleteComponentDesignsWithoutConfirmation(componentDesignGuids));
        }
      }}
    />
  );
}
